import { useGetAggregatedSuppliersDataReport } from "../../../../../../hooks/query/reports";
import { GeneralQuestions, ScopeOneQuestions, ScopeTwoQuestions } from "./AggregatedSuppliersData";
import { MissingDataLabel } from "../../../../components/MissingDataLabel";
import React from "react";
import { showErrorToast } from "../../../../../../utils";
import { useToast } from "@chakra-ui/react";
import { Card } from "../../../../../../components/Card";

function GeneralAndScopeOneAndTwoQuestions({ selectedYear, selectedQuarter, handleExportClick }) {
  const toast = useToast();
  const handleErrors = (err) => {
    if (err.response?.status === 404) {
      return;
    }
    showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message);
  };

  const {
    data: aggregatedData
  } = useGetAggregatedSuppliersDataReport({
    year: selectedYear,
    quarter: selectedQuarter
  }, {
    onError: err => handleErrors(err),
    refetchOnWindowFocus: false,
    cacheTime: 0
  });

  // We are checking for an answer in the turnover's array, because it is required field.
  return <Card boxShadow="xs">
    {aggregatedData && aggregatedData.general && aggregatedData.general.turnover.length > 0 ?
      <>
        <GeneralQuestions data={aggregatedData.general} handleExportClick={handleExportClick} />
        <ScopeOneQuestions data={aggregatedData.scopeOne} />
        <ScopeTwoQuestions data={aggregatedData.scopeTwo} />
      </> :
      <MissingDataLabel />
    }
  </Card>;
}

export default GeneralAndScopeOneAndTwoQuestions;